import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import { eventQueryKeys } from "@/shared/domain/events/hooks";

import { CollectionRecord, CollectionResourceRef } from "../CollectionRecord";

import { collectionQueryKeys } from "./collectionQueryKeys";

interface AddToCollectionVariables {
  collectionId: string;
  resourceOwnerId: string;
  resources: CollectionResourceRef[];
}

export function useAddToCollection() {
  const { collections } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<CollectionRecord, Error, AddToCollectionVariables>({
    mutationFn: ({ collectionId, resourceOwnerId, resources }) =>
      collections.updateCollection(
        collectionId,
        { add_resources: resources },
        { resourceOwnerId },
      ),
    onSuccess: (record) => {
      queryClient.setQueryData(
        collectionQueryKeys.detail(record.collection_id),
        record,
      );
      void queryClient.invalidateQueries({
        queryKey: eventQueryKeys.lists(),
      });
    },
  });
}
